export enum FilterTag {
    ALL = 'all',
    DEPOSITS = 'deposits',
    PREMIUM = 'premium',
    WALLET_REFUND = 'wallet_refund',
}

export const LEDGER_TAG_TABS = [
    { label: 'All', value: FilterTag.ALL },
    { label: 'Deposits', value: FilterTag.DEPOSITS },
    { label: 'Premium', value: FilterTag.PREMIUM },
    { label: 'Wallet Refund', value: FilterTag.WALLET_REFUND },
];
